// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> axia-residential-arc-living-preferred -> the-leila-sweetwater
// Generated: 2026-10-01T17:22:15.055Z
// Counts: 2 design, 94 content, 26 slot group, 3 collection binding, 10 section, 3 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our spacious <span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> bedroom floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h2><h2></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span> in Lithia Springs, GA, where spacious one, two, and three-bedroom floor plans harmonize with vibrant community life. Enjoy proximity to enriching and entertaining spots, like the South Cobb Regional Library, Sweetwater Creek State Park, and Six Flags, ensuring both relaxation and adventure are right at your doorstep. Embrace a lifestyle that inspires!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore <span data-type=\"field-token\" data-field=\"property_address_city\"></span> step by step.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": "Shopping & Retail, Education, Entertainment, Health and Wellness, Nature & Outdoor Attractions, Transportation & Transit, Major Employers & Offices, Restaurants",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibilitystatement.heading": {
    "overrideType": "VALUE",
    "customValue": " ",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibilitystatement.intro": {
    "overrideType": "VALUE",
    "customValue": "<p></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-map.config_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_repli_id"
  },
  "applynowactions.show_application_block": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "callrail-tracking.account_hash": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_call_rail_account_hash"
  },
  "callrail-tracking.company_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_call_rail_company_id"
  },
  "contactus.form.bedroom_list_type": {
    "overrideType": "VALUE",
    "customValue": "derived",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-schedule-tour-iframe.height": {
    "overrideType": "VALUE",
    "customValue": "1600",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-schedule-tour-iframe.height_mobile": {
    "overrideType": "VALUE",
    "customValue": "1600",
    "generatedValue": null,
    "mappedField": null
  },
  "iframe-embed.height": {
    "overrideType": "VALUE",
    "customValue": "2000",
    "generatedValue": null,
    "mappedField": null
  },
  "iframe-embed.url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_eliseai_tour_scheduler_url"
  },
  "knock-chatbot.api_token": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_knock_company_token"
  },
  "preferredemployerprogram.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Exclusive Apartment Offers for Employees in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.form.source": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.scheduler_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_eliseai_tour_scheduler_url"
  },
  "scheduleatour.show_tour_scheduler": {
    "overrideType": "VALUE",
    "customValue": "false",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.height": {
    "overrideType": "VALUE",
    "customValue": "1400",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_eliseai_tour_scheduler_url"
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_fav_icon"
  },
  "amenities-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Our luxury apartments in Lithia Springs, GA, have a pool, fitness center, and lush green spaces. With modern finishes like <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/virtual-tour\">granite counters and garden tubs</a>, your new home at <span data-type=\"field-token\" data-field=\"property_name\"></span> is designed for relaxation and style. Embrace the life you deserve!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At <span data-type=\"field-token\" data-field=\"property_name\"></span> in Lithia Springs, GA, life unfolds in beautifully designed one, two, and three-bedroom apartments, boasting granite counters and stainless steel appliances. Enjoy resort-style amenities like a sparkling swimming pool, state-of-the-art fitness center, and serene green spaces. Your ideal home awaits—lease online today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At <span data-type=\"field-token\" data-field=\"property_name\"></span>, we offer <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">spacious floor plans</a> designed to suit every lifestyle, from cozy one-bedroom retreats to expansive three-bedroom homes. Each residence blends comfort and modern elegance. Curious about the availability of our rentals in Lithia Springs, GA? Reach out to our leasing team today—your dream apartment awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At <span data-type=\"field-token\" data-field=\"property_name\"></span>, your ideal home awaits! Choose from our diverse range of one, two, and three-bedroom apartments in Lithia Springs, GA, with a washer and dryer, perfectly designed to fit your lifestyle. Browse our available apartment homes and <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/amenities\">amenities</a> today, and let your journey to comfort and style begin!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At <span data-type=\"field-token\" data-field=\"property_name\"></span>, life unfolds amid luxurious <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/amenities\">amenities</a> and <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">stunning floor plans.</a> Imagine soaking up the sun by the resort-style pool or unwinding in your stylish three-bedroom haven. With beautifully landscaped courtyards, top-notch fitness facilities, and easy access to Thornton Road shopping, you'll be able to picture yourself living in the vibrant community of your dreams!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "_template:hyperlocal::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Experience a resort-inspired swimming pool right here in Lithia Springs. Dive into relaxation at The Leila Sweetwater's spectacular pool setting.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/resort-inspired-swimming-pool-lithia-springs::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Experience a resort-inspired swimming pool right here in Lithia Springs. Dive into relaxation at The Leila Sweetwater's spectacular pool setting.</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "_template:hyperlocal::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resort-Inspired Pool in Lithia Springs</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At <span data-type=\"field-token\" data-field=\"property_name\"></span> in Lithia Springs, GA, luxury meets everyday living. Choose from thoughtfully designed one, two, or three-bedroom layouts, each featuring designer finishes and resort-style amenities. Enjoy sun-drenched relaxation by the pool, invigorating workouts in our fitness center, and cozy gatherings by the fire. Find your perfect home today through our interactive community map!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span data-type=\"field-token\" data-field=\"property_name\"></span> offers more than just stunning <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">one, two, and three-bedroom floor plans</a>. Our apartments are located near downtown Douglasville and WellStar Douglas Hospital in Lithia Springs. Enjoy the convenience of other nearby major employers and attractions, like Sweetwater Creek State Park, the Douglas County Museum of History and Art, and Falcon Stadium. Uncover your vibrant new lifestyle today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span> where your furry friends are part of the family! Our pet-friendly <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">apartments</a> in Lithia Springs, GA, include a dog park. With ample space for two pets and an accessible pet policy, your home is just as cozy for them as it is for you. Embrace a vibrant lifestyle that truly accommodates everyone.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Cats and dogs allowed, maximum 2 pets per unit. One-time pet fee: $350-$700. Monthly pet rent: $50 per pet.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<p>Please contact leasing office for more information.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.stat_monthly_rent_value": {
    "overrideType": "VALUE",
    "customValue": "50",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.stat_pet_deposit_label": {
    "overrideType": "VALUE",
    "customValue": "<p>Max Weight</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.stat_pet_deposit_value": {
    "overrideType": "VALUE",
    "customValue": "25 lbs",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span>, the premier apartment community nestled in the heart of Lithia Springs, GA. Offering a variety of spacious floor plans, choose from our stylish <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">one, two, or three-bedroom apartments </a>designed with your comfort in mind. Each residence showcases luxurious features such as stainless steel appliances, 42\" shaker-style cabinetry, granite countertops, and garden tubs that transform everyday living into an extraordinary experience. At <span data-type=\"field-token\" data-field=\"property_name\"></span>, we believe in delivering a lifestyle that balances luxury, convenience, and community. Residents can unwind in our <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/amenities\">resort-inspired swimming pool</a>, complete with a sun deck, or take advantage of our state-of-the-art fitness center boasting free weights and modern workout equipment. Gather with friends in our resident social lounge or cozy up by the outdoor fireplace lounge, all while warming up to the beautiful landscaped courtyards and green spaces that make our lively community feel like home. You’ll appreciate the ease of on-site leasing and management teams, as well as our dedicated service team, ready to assist with your needs. Enjoy the convenience of controlled access, garages, and a centralized mail hub. <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/pet-policy\">Pet owners</a> will adore our PupPlay Park, while car enthusiasts can pamper their vehicles at our AutoSpa. Experience the blend of comfort and luxury living at <span data-type=\"field-token\" data-field=\"property_name\"></span>. Don’t miss the opportunity to <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/virtual-tour\">discover your new home today</a>—browse our availability or schedule a tour to explore our community!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.tab_community_label": {
    "overrideType": "VALUE",
    "customValue": "Spaces Designed Around You",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.tab_interior_label": {
    "overrideType": "VALUE",
    "customValue": "Thoughtfully Designed Interiors",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span> in Lithia Springs, GA! Our <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">versatile floor plans</a> feature one, two, and three-bedroom apartments tailored to your lifestyle. Access your resident portal today to effortlessly pay rent, schedule maintenance, and manage all your housing needs in one convenient place. Experience modern living at its finest!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At <span data-type=\"field-token\" data-field=\"property_name\"></span> in Lithia Springs, GA, our residents rave about the vibrant community atmosphere, stating, “It's a great place to call home, with friendly neighbors and helpful staff.” Dive into our reviews and see why making <span data-type=\"field-token\" data-field=\"property_name\"></span> your home is a decision you'll cherish!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At <span data-type=\"field-token\" data-field=\"property_name\"></span>, find your ideal space among our thoughtfully designed <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">one, two, and three-bedroom</a> Lithia Springs, GA rentals. Experience the perfect blend of comfort and community—schedule a tour today and hear firsthand from residents who call this vibrant community home!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience the charm of <span data-type=\"field-token\" data-field=\"property_name\"></span>! With thoughtfully designed <a rel=\"noopener noreferrer nofollow\" class=\"richtext-link\" href=\"/floor-plans\">one, two, and three-bedroom apartments</a> near Atlanta, GA, your perfect home awaits. Step inside and envision your future—take a virtual tour of our community and floor plans, and see why <span data-type=\"field-token\" data-field=\"property_name\"></span> is your ideal destination!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_online_leasing_url"
      }
    }
  },
  "_template:hyperlocal::hyperlocalhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_featured_image"
      }
    }
  },
  "featuring/apartment-with-pool-monroe-30655::hyperlocalhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_featured_image"
      }
    }
  },
  "amenitieshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57d-c8ac-7784-acdb-849dae555272.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and a covered cabana."
      }
    }
  },
  "contacthero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-8a38-753e-a79e-5e906faa01f1.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern white building with dark windows and a prominent entrance, surrounded by landscaping and a parking lot."
      }
    }
  },
  "ctasection.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-2fc2-731e-8e17-21bd1c8f6af8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a king-size bed, blue accent wall with artwork, and a window overlooking trees."
      }
    }
  },
  "ctasection.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0cab1-67b6-7344-81a9-f8d585c2bee4.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Couple preparing breakfast in a bright, modern kitchen."
      }
    }
  },
  "ctasection.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57c-6947-779a-9bd2-36c3720b8db8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with white cabinets, stainless steel appliances, and an island with seating."
      }
    }
  },
  "floorplanshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-6afe-7553-ba83-58f719aa91cb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a navy blue sofa, leather accent chair, coffee table, and desk."
      }
    }
  },
  "floorplanslist.card_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-21d3-72e7-8e19-9be925ad066e.webp"
      }
    }
  },
  "floorplanslist.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-2207-74af-8245-7cfef434a8e4.webp"
      }
    }
  },
  "floorplanslist.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57c-786b-7423-a02b-e1ad61fa536a.webp"
      }
    }
  },
  "floorplanslist.card_viewall": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-2fc2-731e-8e17-21bd1c8f6af8.webp"
      }
    }
  },
  "galleryhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-434b-707d-a22c-62aecf681a50.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor fire pit with seating and hammock."
      }
    }
  },
  "interactivemaphero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-32c0-70bd-b7f3-417759c5049d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a king-size bed, navy accent wall with abstract art, and open closet."
      }
    }
  },
  "neighborhoodcallout.image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0cab1-56ff-7065-a925-b895c7c880da.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Three friends enjoying wine on a balcony with city view"
      }
    }
  },
  "neighborhoodcallout.image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0cab1-6507-770e-8aa8-b4b138803677.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Woman tying her running shoes outdoors, smiling."
      }
    }
  },
  "neighborhoodcallout.image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a579-646f-72a8-9f2b-3e5132621ea7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor seating area with chairs and a mural on the side of a building."
      }
    }
  },
  "neighborhoodhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0cab1-65d6-7659-89a5-d2315fb09dfc.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "People socializing and enjoying a barbecue in a grassy outdoor area with string lights and colorful flags."
      }
    }
  },
  "petpolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-5418-7479-bc2c-435acaf695c6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dog park area with agility equipment and fenced enclosure with apartment buildings in the background."
      }
    }
  },
  "scheduleatourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-785a-72b8-81c0-4cac88ca21ae.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Communal dining area with a large live-edge wood table and seating, lounge area with sofas and chairs, and a mounted television."
      }
    }
  },
  "virtualtourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-2205-70af-bf7e-29abeeb36a5e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living room with navy sofa, tan accent chair, TV, and large window."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": [
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58,
      59,
      60,
      61
    ],
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "callrail-tracking",
      "blockId": "callrail-tracking",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "knock-chatbot",
      "blockId": "knock-chatbot",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 8
    }
  ],
  "interactive-map": [
    {
      "sectionId": "apartment-sync-map",
      "blockId": "apartment-sync-map",
      "position": 9,
      "gridSpanMobile": 12
    }
  ],
  "schedule-a-tour": [
    {
      "sectionId": "elise-schedule-tour-iframe",
      "blockId": "elise-schedule-tour-iframe",
      "position": 8,
      "visible": false
    },
    {
      "sectionId": "elise-schedule-tour-iframe-2",
      "blockId": "elise-schedule-tour-iframe",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  },
  "_section.block:iframe-embed": {
    "properties": {
      "overflow": "hidden"
    }
  },
  "_section.block:elise-schedule-tour-iframe": {
    "properties": {
      "paddingTop": "20px",
      "backgroundColor": "#f7f7f7"
    }
  }
};
